import shellServices from "./shell-services.jpg";
import capDrawing from "./cap-drawing.jpg";
import capPeople from "./cap-b-people.jpg"
import capDocs from "./cap-docs.png";
import capChat from "./cap-chat.jpg";
import capCubes from "./cap-cubes.png";
import capDashboard from "./cap-dashboard.jpg";
import capWorkflow from "./cap-workflow.png";
import capBProcess from "./cap-b-process.jpg";
import capBBottleneck from "./cap-b-bottleneck.png";
import capBMap from "./cap-b-map.jfif";
import capBWorkshop from "./cap-b-workshop.jfif";
import capBSystems from "./cap-b-systems.jfif";
import capCApi from "./cap-c-api.jfif";
import capCBim from "./cap-c-bim.jpg";
import capCErp from "./cap-c-erp.jfif";
import capCSync from "./cap-c-sync.jfif";
import capCDocs from "./cap-c-docs.png";
import capCNotify from "./cap-c-notify.jfif";
import capTOnboard from "./cap-t-onboard.jfif";
import capTTrain from "./cap-t-train.jpg";
import capTField from "./cap-t-field.jfif";
import capTAdopt from "./cap-t-adopt.jpg";

import capTSupport from "./cap-t-support.jpg";
import support from "./cap-t-suport.jpg";
import capWMarketing from "./cap-w-marketing.jfif";
import capWProduct from "./cap-w-product.jpg";
import capWCms from "./cap-w-cms.jfif";
import capWSeo from "./cap-w-seo.png";
import capWForms from "./cap-w-forms.jfif";
import capWIntegrate from "./cap-w-integrate.png";


export const serviceShellImage = shellServices;



export const serviceCapabilityImages = {
  suportT:support,
  drawing: capDrawing,
  docs: capDocs,
  chat: capChat,
  cubes: capCubes,
  dashboard: capDashboard,
  bProcess: capBProcess,
  bBottleneck: capBBottleneck,
  bMap: capBMap,
  bWorkshop: capBWorkshop,
  bPeople: capPeople,
  bSystems: capBSystems,
   cApi: capCApi,
   workflow: capWorkflow,
  cBim: capCBim,
  cErp: capCErp,
  cSync: capCSync,
  cDocs: capCDocs,
  cNotify: capCNotify,

  tOnboard: capTOnboard,
  tTrain: capTTrain,
  tField: capTField,
  tAdopt: capTAdopt,
  tSupport: capTSupport,
  wMarketing: capWMarketing,
  wProduct: capWProduct,
  wCms: capWCms,
  wSeo: capWSeo,
  wForms: capWForms,
  wIntegrate: capWIntegrate,
};
